/////////////// LIB. ///////////////
////////////////////////////////////

// ...

////////////// UTIL. ///////////////
////////////////////////////////////

// ...

////////// EVENT HANDLERS //////////
////////////////////////////////////

// ...

////////////// ASSETS //////////////
////////////////////////////////////

const logArgs = { eventName: "stChH_stateChange", inline: true, disabled: false };
const msgs = {
  change: (CHANGE) => [`hidden: ${CHANGE}`],
};

//////////// HDL. DEF. /////////////
////////////////////////////////////

export default function stChH_hidden(CHANGES) {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { hidden } = CHANGES;
  this.logger("state-change", msgs.change(hidden), "default", logArgs);

  ////// State change execution //////
  ////////////////////////////////////

  this.element.dataset.hidden = hidden ? "true" : "false";
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
